import MessagesList from '@/components/MessagesList/MessagesList'

export default {
  components: { MessagesList },
  props: {
    orderId: Number,
  },
}
